import _ from 'lodash';
import * as moment from 'moment';
import { v4 as uuid } from 'uuid';
import ApiService from '../../../service/apiService';
import logUtils from '../../../HelperMethods/LogUtils';

const componentName = 'ManageMapView';

// eslint-disable-next-line import/prefer-default-export
export const types = {
  LOADING_ROUTE_DATA: `${componentName}_LOADING_ROUTE_DATA`,
  LOADED_ROUTE_DATA_SUCCESSFULLY: `${componentName}_LOADED_ROUTE_DATA_SUCCESSFULLY`,
  LOADED_ROUTE_DATA_FAILED: `${componentName}_LOADED_ROUTE_DATA_FAILED`,
  LOADING_GEOFENCE_EVENTS: `${componentName}_LOADING_GEOFENCE_EVENTS`,
  LOADED_GEOFENCE_EVENTS_SUCCESSFULLY: `${componentName}_LOADED_GEOFENCE_EVENTS_SUCCESSFULLY`,
  LOADED_GEOFENCE_EVENTS_FAILED: `${componentName}_LOADED_GEOFENCE_EVENTS_FAILED`,
  LOADING_USERS_LOCATIONS: `${componentName}_LOADING_USERS_LOCATIONS`,
  LOADED_USERS_LOCATIONS_SUCCESSFULLY: `${componentName}_LOADED_USERS_LOCATIONS_SUCCESSFULLY`,
  LOADED_USERS_LOCATIONS_FAILED: `${componentName}_LOADED_USERS_LOCATIONS_FAILED`,
  LOADING_RUN_LIST: `${componentName}_LOADING_RUN_LIST`,
  LOADED_RUN_LIST_SUCCESSFULLY: `${componentName}_LOAD_RUN_LIST_SUCCESS`,
  LOAD_RUN_LIST_FAILED: `${componentName}_LOAD_RUN_LIST_FAILUED`,
  CLEAR_RUN_OPTIONS: `${componentName}_CLEAR_RUN_OPTIONS`,
  LOAD_PLANNED_ROUTE_PARTICULAR_RUN: `${componentName}_LOAD_PLANNED_ROUTE_PARTICULAR_RUN`,
  LOADED_PLANNED_ROUTE_PARTICULAR_RUN_SUCCESSFULLY: `${componentName}_LOAD_PLANNED_ROUTE_PARTICULAR_RUN_SUCCESSFULLY`,
  LOADED_PLANNED_ROUTE_PARTICULAR_RUN_FAILED: `${componentName}_LOAD_PLANNED_ROUTE_PARTICULAR_RUN_FAILED`,
  SET_STOP_DICT: `${componentName}_SET_STOP_DICT`,
  SELECT_STOP: `${componentName}_SELECT_STOP`,
  UPDATE_ACTUAL_ROUTE_DATA: `${componentName}_UPDATE_ACTUAL_ROUTE_DATA`,
};

function gethhmmTimeFormat(isoString) {
  return isoString ? moment(isoString).format('hh:mm a') : '';
}

function getTimeDiffInMinutes(time1, time2) {
  return time1 && time2 && moment(time1).diff(moment(time2), 'minutes');
}

function modifyPlannedObjects(plannedRoute) {
  let stops = [];
  if (plannedRoute && plannedRoute.length) {
    stops = plannedRoute.map((stop) => ({
      stopId: stop.id,
      stopName: stop.name,
      xid: stop.xid,
      userTimings: `${gethhmmTimeFormat(stop.arrivalAt)} to ${gethhmmTimeFormat(stop.exitAt)}`,
      durationInMinutes: getTimeDiffInMinutes(stop.exitAt, stop.arrivalAt),
      numberOfTasks: stop.numberOfTasks,
      location: {
        lat: stop.latitude,
        lng: stop.longitude,
      },
    }));
  }
  return { stops, locations: [] };
}

function modifyActualObject(actualRoute, plannedRoute) {
  const plannedStopsXidDict = _.keyBy(plannedRoute.stop, 'xid');
  const stops = [];
  const locations = [];
  if (actualRoute) {
    if (actualRoute.stops) {
      actualRoute.stops.forEach((stop) => {
        stops.push({
          stopId: (plannedStopsXidDict[stop.stopXid] && plannedStopsXidDict[stop.stopXid].xid) || uuid(),
          xid: stop.stopXid,
          stopName: stop.stopName,
          userTimings: `${gethhmmTimeFormat(stop.arrivedAt)} to ${gethhmmTimeFormat(stop.exitedAt)}`,
          durationInMinutes: getTimeDiffInMinutes(stop.exitedAt, stop.arrivedAt),
          location: {
            lat: stop.latitude,
            lng: stop.longitude,
          },
        });
      });
    }
    if (actualRoute.locations) {
      actualRoute.locations.forEach((location) => {
        locations.push({
          location: {
            lng: location[0],
            lat: location[1],
          },
          time: location[2],
        });
      });
    }
  }
  return { stops, locations };
}

function comparePlannedVsActualRouteData(routeData) {
  if (
    routeData.planned &&
    routeData.planned.stops &&
    routeData.planned.stops.length &&
    routeData.actual &&
    routeData.actual.stops &&
    routeData.actual.stops.length
  ) {
    const plannedStopData = routeData.planned.stops.filter((s) => s.xid);
    const actualStopData = routeData.actual.stops.filter((s) => s.xid);
    let plannedIndex = 0;
    let actualIndex = 0;
    while (actualIndex < actualStopData.length) {
      if (
        plannedIndex < plannedStopData.length &&
        plannedStopData[plannedIndex].xid === actualStopData[actualIndex].xid
      ) {
        plannedIndex += 1;
      } else {
        actualStopData[actualIndex].doesNotMatchWithPlanned = true;
      }
      actualIndex += 1;
    }
  }
}

export function loadRouteData(userId, date) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_ROUTE_DATA });
    try {
      const response = await ApiService.getEngineRunListPlannedAndActualRouteForUserAndDate(userId, date);
      const success = _.get(response, 'data.rpcService.success');
      if (success) {
        const output = _.get(response, 'data.rpcService.output');
        const outputObject = JSON.parse(output);
        outputObject.planned = modifyPlannedObjects(outputObject.planned);
        outputObject.actual = modifyActualObject(outputObject.actual, outputObject.planned);
        comparePlannedVsActualRouteData(outputObject);
        const { planned, actual, engineRunList = [] } = outputObject;
        dispatch({
          type: types.LOADED_ROUTE_DATA_SUCCESSFULLY,
          routeData: {
            planned,
            actual,
          },
          options: engineRunList,
        });
        return;
      }
      throw new Error(_.get(response, 'data.rpcService.message') || 'API Failed');
    } catch (error) {
      logUtils.logError(error, 'Could not fetch actual vs planned route data');
      dispatch({ type: types.LOADED_ROUTE_DATA_FAILED });
    }
  };
}

export function clearRunOptions() {
  return (dispatch) => {
    dispatch({ type: types.CLEAR_RUN_OPTIONS });
  };
}

export function fetchPlannedRouteForParticularRun(userId, date, runId) {
  return async (dispatch) => {
    dispatch({ type: types.LOAD_PLANNED_ROUTE_PARTICULAR_RUN });
    try {
      const response = await ApiService.getPlannedRouteForParticularRun(userId, date, runId);
      const success = _.get(response, 'data.rpcService.success');
      if (success) {
        const output = _.get(response, 'data.rpcService.output');
        const outputObj = JSON.parse(output);
        const planned = modifyPlannedObjects(outputObj.planned);
        dispatch({ type: types.LOADED_PLANNED_ROUTE_PARTICULAR_RUN_SUCCESSFULLY, planned });
        return;
      }
      throw new Error(_.get(response, 'data.rpcService.message') || 'API Failed');
    } catch (error) {
      logUtils.logError(error, 'Could not fetch planned route for selected run');
      dispatch({ type: types.LOADED_PLANNED_ROUTE_PARTICULAR_RUN_FAILED });
    }
  };
}

export function loadGeofenceEvents(userId, date) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_GEOFENCE_EVENTS });
    try {
      const response = await ApiService.getGeofenceEventsByUser(userId, date);
      const success = _.get(response, 'data.rpcService.success');
      if (success) {
        const output = _.get(response, 'data.rpcService.output');
        const items = JSON.parse(JSON.parse(output));
        dispatch({ type: types.LOADED_GEOFENCE_EVENTS_SUCCESSFULLY, items });
        return;
      }
      throw new Error(_.get(response, 'data.rpcService.message') || 'API Failed');
    } catch (error) {
      logUtils.logError(error, 'Could not fetch geofence events for the user');
      dispatch({ type: types.LOADED_GEOFENCE_EVENTS_FAILED });
    }
  };
}

export function loadUsersLocations(fieldId) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_USERS_LOCATIONS });
    try {
      const response = await ApiService.getUsersLocationByField(fieldId);
      const success = _.get(response, 'data.rpcService.success');
      if (success) {
        const output = _.get(response, 'data.rpcService.output');
        const users = JSON.parse(JSON.parse(output));
        dispatch({ type: types.LOADED_USERS_LOCATIONS_SUCCESSFULLY, users });
        return;
      }
      throw new Error(_.get(response, 'data.rpcService.message') || 'API Failed');
    } catch (error) {
      logUtils.logError(error, 'Could not fetch users latest location');
      dispatch({ type: types.LOADED_USERS_LOCATIONS_FAILED });
    }
  };
}

export function loadUsersLocationsViaSubscription(users) {
  return async (dispatch, getState) => {
    const {
      taskViewPageReducer: { selectedUserIds = [] },
      manageMapViewReducer: {
        routeData: { actual },
      },
    } = getState();
    // selectedUsers length 1
    // update the path
    if (selectedUserIds?.length === 1) {
      const [selectedUserId] = selectedUserIds;
      const reqUser = users.find((user) => user.id === selectedUserId);
      const actualRouteClone = JSON.parse(JSON.stringify(actual ?? {}));
      const actualLocations = actualRouteClone?.locations ?? [];
      const lastIndex = actualLocations?.length ? actualLocations.length - 1 : 0;
      if (
        reqUser?.position &&
        _.difference(reqUser.position, Object.values(actualLocations?.[lastIndex]?.location ?? {}))?.length
      ) {
        actualLocations.push({
          location: { lat: reqUser.position[1], lng: reqUser.position[0] },
          time: reqUser?.sampleTime,
        });
        dispatch({ type: types.UPDATE_ACTUAL_ROUTE_DATA, actual: actualRouteClone });
      }
    }
    dispatch({ type: types.LOADED_USERS_LOCATIONS_SUCCESSFULLY, users });
  };
}

export function selectStop(stopId, isStopMarkerClicked = false) {
  return (dispatch) => {
    dispatch({ type: types.SELECT_STOP, stopId, isStopMarkerClicked });
  };
}

export function setStopsDict(stopsDict) {
  return { type: types.SET_STOP_DICT, stopsDict };
}
